import {Link} from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Logo from '../images/logo@2x.png';

const Footer = ({siteTitle}) => (
  <footer className="footer">
    <div className="container">
      <div className="columns is-multiline">
        <div className="column is-2">
          <Link className="navbar-item" to="/" onClick={() => this.handleModalClose()}>
            <img src={Logo} width="112" height="28"/>
          </Link>
        </div>
        <div className="column is-2">
          <p className="has-text-weight-bold">General</p>
          <ul>
            <li>
              <Link to="/" className="footer-link">Home</Link>
            </li>
            <li>
              <Link to="/about" className="footer-link">About</Link>
            </li>
            <li>
              <Link to="/events" className="footer-link">Events</Link>
            </li>
            <li>
              <Link to="/podcasts" className="footer-link">Podcasts</Link>
            </li>
            <li>
              <Link to="/blog" className="footer-link">Blog</Link>
            </li>
          </ul>

        </div>
        <div className="column is-2">
          <p className="has-text-weight-bold">Candidates</p>
          <ul>
            <li>
              <Link to="/career-advice" className="footer-link">Career Advice</Link>
            </li>
            <li>
              <Link to="/resume-creation" className="footer-link">Resume Creation</Link>
            </li>
            <li>
              <Link to="/relocation" className="footer-link">Relocation</Link>
            </li>
            <li>
              <Link to="/interview-coaching" className="footer-link">Interview Coaching</Link>
            </li>
            <li>
              <Link to="/open-positions" className="footer-link">Open Positions</Link>
            </li>

            <li>
              <Link to="/blog" className="footer-link">Blog</Link>
            </li>
          </ul>

        </div>
        <div className="column is-2">
          <p className="has-text-weight-bold">Recruitment Businesses</p>
          <ul>
            <li>
              <Link to="recruitment-services" className="footer-link">
                Recruitment Services
              </Link>
            </li>
            <li>
              <Link to="training" className="footer-link">
                Training
              </Link>
            </li>
            <li>
              <Link to="advisory" className="footer-link">
                Advisory
              </Link>
            </li>
          </ul>
        </div>
        <div className="column">
          <span>Join our newsletter to stay up to date on the latest recruitment career advice, news, and events</span>
          <br/>
          <a className="has-text-primary has-text-weight-bold" href="https://dgrecruit.us3.list-manage.com/subscribe/post?u=578907c87fa07d1e19c862f89&amp;id=12bca49d87" target="_blank">Subscribe Now <i className="fas fa-long-arrow-alt-right"></i></a>
        </div>
      </div>

      <div className="icon-bar">
        <a href="https://twitter.com/dgrecruit" className="social twitter">
          <i className="fab fa-twitter"></i>
        </a>
        <a href="https://www.facebook.com/dgrecruit/" className="social facebook">
          <i className="fab fa-facebook"></i>
        </a>
        <a href="https://www.linkedin.com/company/dgrecruit/" className="social linkedin">
          <i className="fab fa-linkedin"></i>
        </a>
        <a href="https://instagram.com/dgrecruit/" className=" social instagram">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://instagram.com/dgrecruit/" className="social youtube">
          <i className="fab fa-youtube"></i>
        </a>
      </div>
      <div>
        <p className="site-name is-pulled-left" href="http://www.dgrecruit.com/" rel="home">© 2019 DG Recruit. All rights reserved.</p>

        <div className="footer-right is-pulled-right">
          <Link to="/privacy-policy" className="imprint">
            Privacy Policy
          </Link>
          <Link to="/terms-service" className="imprint" style={{
            marginLeft: "10px"
          }}>
            Terms of Service
          </Link>
        </div>
      </div>

    </div>
  </footer>
)

Footer.propTypes = {
  siteTitle: PropTypes.string
}

Footer.defaultProps = {
  siteTitle: ``
}

export default Footer
